import * as React from "react";
const WidgetIcon6 = (props) => (
  <svg
    width={43}
    height={44}
    viewBox="0 0 43 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.687 0.335938H28.813C30.6913 0.33591 32.2415 0.335886 33.5043 0.439059C34.8158 0.546218 36.0215 0.776201 37.1539 1.35321C38.9101 2.24803 40.3379 3.67585 41.2327 5.43203C41.8097 6.56448 42.0397 7.77012 42.1469 9.08168C42.2501 10.3445 42.25 11.8946 42.25 13.7729V21.8977C42.25 23.776 42.2501 25.3261 42.1469 26.5889C42.0397 27.9004 41.8097 29.1061 41.2327 30.2385C40.3379 31.9947 38.9101 33.4225 37.1539 34.3174C36.0215 34.8944 34.8158 35.1243 33.5043 35.2315C32.2415 35.3347 30.6913 35.3347 28.813 35.3346H28.3233L21.25 43.5884L14.1767 35.3346H13.687C11.8087 35.3347 10.2585 35.3347 8.99574 35.2315C7.68418 35.1243 6.47854 34.8944 5.34609 34.3174C3.58991 33.4225 2.16209 31.9947 1.26728 30.2385C0.690264 29.1061 0.46028 27.9004 0.353122 26.5889C0.249948 25.3261 0.249972 23.7759 0.250001 21.8977V13.7729C0.249972 11.8947 0.249948 10.3445 0.353121 9.08168C0.46028 7.77012 0.690263 6.56448 1.26728 5.43203C2.16209 3.67585 3.58991 2.24803 5.34609 1.35321C6.47854 0.776201 7.68418 0.546218 8.99574 0.439059C10.2585 0.335886 11.8087 0.33591 13.687 0.335938ZM14.2501 8.70277L22.2166 16.6693L14.2501 24.6358L10.9502 21.3359L15.6169 16.6693L10.9502 12.0026L14.2501 8.70277ZM30.5833 21.3359H21.25V26.0026H30.5833V21.3359Z"
      fill="#B1B1B1"
    />
  </svg>
);
export default WidgetIcon6;
